/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './collapse.css';

const Collapse = (props) => {
  const { uniqueId, title, body, customBody = false, open = false } = props;
  return (
    <React.Fragment key={uniqueId}>
      <div className='panel panel-default util'>
        <div
          className='panel-heading'
          role='tab'
          id={`headingOne${uniqueId}`}
          data-toggle='collapse'
          data-parent='#accordion'
          href={`#${uniqueId}`}
          aria-expanded='true'
          aria-controls='collapseOne'
        >
          <h4 className='panel-title'>
            <a role='button'>{title}</a>
          </h4>
        </div>
        <div id={uniqueId} className={`panel-collapse collapse ${open ? 'in' : ''}`} role='tabpanel' aria-labelledby={`headingOne${uniqueId}`}>
          { customBody || (<div className='panel-body'>{body}</div>) }
        </div>
      </div>
    </React.Fragment>
  );
};

export default Collapse;
